import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { QuestionBase } from '../../domain/question.base';
import { QuestionComponent } from '../question.component';
import { ScrollService } from '../scroll.service';

@Component({
  selector: `crds-question-signature`,
  template: `
    <div *ngIf="show" [formGroup]="form">
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key"
        >{{ question.label }}
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question" [message]="question.errorMessage"></crds-form-error>
      </label>
      <crds-signature-pad [form]="form" [key]="question.key" #signatureInput></crds-signature-pad>

      <crds-question-hint [question]="question"></crds-question-hint>
    </div>
  `
})
export class SignatureQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form;
  @Input() question: QuestionBase<string>;
  @ViewChild('signatureInput') input;
  type: string;

  constructor(private scrollService: ScrollService) {
    super();
  }

  ngOnInit() {
    this.scrollService.scrollObservable.subscribe(documentId => {
      if (documentId === this.question.key) {
        this.input.nativeElement.scrollIntoView();
      }
    });
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ? this.showIf : true;
    return (
      (this.question.showIfPopulated !== true || this.value) && showIfQuestionPopulated && this.question.show !== false
    );
  }
}
